@if (attribute) {
  <div [class.invisible]="isLoading"
       [ngClass]="{'invalid-list': hasError}"
       class="d-flex justify-content-between">
    <app-field-label [attribute]="attribute"
    [passportId]="passportId"></app-field-label>
    <ix-button (click)="addListItem()" icon="add-circle"
               [id]="'editPassportAddButton_' + fullValuePath"
               onkeyPress=""
               variant="subtle-tertiary">Add
    </ix-button>
  </div>
  @if (hasError) {
    <ix-typography format="label" textColor="alarm">{{ createInvalidText(control) }}</ix-typography>
  }
  <ix-layout-grid class="pe-0 ps-0 pt-2">
    @if (!passData || (Array.isArray(passData) && passData.length === 0)) {
      <ix-row class="d-flex justify-content-center">
        <ix-col class="text-center" size="12">
          <ix-empty-state
            (actionClick)="addListItem()"
            header="{{'battery_pass.edit.empty_list.attribute_header' | translate}}"
            layout="compact"
            subHeader="{{'battery_pass.edit.empty_list.attribute_subheader' | translate}}"
          ></ix-empty-state>
        </ix-col>
      </ix-row>
    }
    @if (passData && Array.isArray(passData) && passData.length > 0) {
      @for (data of passData; track i; let i = $index) {
        <ix-row
          class="expandable-row">
          <ix-icon-button (click)="removeItem(i)" icon="trashcan"
          onkeyPress="" variant="subtle-primary"></ix-icon-button>
          <ix-col class="py-0 ps-3 pe-0 border-left">
            <app-text-input
              [attribute]="attribute"
              [passportId]="passportId"
              [fullValuePath]="`${fullValuePath}[${i}]`"
              [saveFunction]="saveFunction"
              [passData]="data"
            ></app-text-input>
          </ix-col>
        </ix-row>
      }
    }
  </ix-layout-grid>
}
<ix-spinner [class.d-none]="!isLoading"></ix-spinner>
